import { getTranslatedProperty, getCategoryRoute } from '@shopware-pwa/helpers-next';

export function useNavigationLinkResolver(navigationElement) {
    const isExternalLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'external' ||
        navigationElement.linkType === 'external';

    const isCategoryLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'category' ||
        navigationElement.linkType === 'category';

    const isProductLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'product' || navigationElement.linkType === 'product';

    const isLandingPageLink =
        getTranslatedProperty(navigationElement, 'linkType') === 'landing_page' ||
        navigationElement.linkType === 'landing_page';

    const isInternalLink = isProductLink || isCategoryLink || isLandingPageLink;

    const resolveLink = () => {
        if (isExternalLink) {
            return navigationElement.externalLink;
        }

        return getCategoryRoute(navigationElement);
    };

    return {
        isInternalLink,
        isExternalLink,
        resolveLink,
    };
}
